// extracted by mini-css-extract-plugin
module.exports = {"modal":"CatalogCluezDownloadModal_modal__1_MJt","backdrop":"CatalogCluezDownloadModal_backdrop__xQFpd"};